export default __webpack_public_path__ + "static/media/Bld.c1a78923.jpg";